var map = {
	"./admin.json": 8186,
	"./admin_budgets.json": 8511,
	"./admin_integrations.json": 7816,
	"./admin_users.json": 997,
	"./analytics.json": 5785,
	"./approvals.json": 8505,
	"./auth.json": 5021,
	"./chat.json": 5645,
	"./common.json": 9802,
	"./feed.json": 6251,
	"./marketplace.json": 4358,
	"./nav.json": 5128,
	"./nominations.json": 6294,
	"./profile.json": 1432,
	"./recognition.json": 3014,
	"./settings.json": 2974,
	"./teams.json": 9551,
	"./validation.json": 1824,
	"./wallet.json": 470,
	"./widgets.json": 4916,
	"./workvivo.json": 1684,
	"locales/en/admin.json": 8186,
	"locales/en/admin_budgets.json": 8511,
	"locales/en/admin_integrations.json": 7816,
	"locales/en/admin_users.json": 997,
	"locales/en/analytics.json": 5785,
	"locales/en/approvals.json": 8505,
	"locales/en/auth.json": 5021,
	"locales/en/chat.json": 5645,
	"locales/en/common.json": 9802,
	"locales/en/feed.json": 6251,
	"locales/en/marketplace.json": 4358,
	"locales/en/nav.json": 5128,
	"locales/en/nominations.json": 6294,
	"locales/en/profile.json": 1432,
	"locales/en/recognition.json": 3014,
	"locales/en/settings.json": 2974,
	"locales/en/teams.json": 9551,
	"locales/en/validation.json": 1824,
	"locales/en/wallet.json": 470,
	"locales/en/widgets.json": 4916,
	"locales/en/workvivo.json": 1684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4254;